import { highlightText } from '@/shared/parse'

export const HighlightedText = (props: {
  text?: string;
  filter: string[];
}) => {
  const { text, filter } = props;
  if (!text || filter.length === 0) {
    return <span>{text || ''}</span>;
  }
  const html = highlightText(text, filter);
  if (text === html) {
    return <span>{text || ''}</span>;
  }
  return <span dangerouslySetInnerHTML={{ __html: html }} ></span>
}